package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBriefcase
import com.varabyte.kobweb.silk.components.icons.fa.FaLocationDot
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.FormlocalisationStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input


@Composable
fun LocalisationForm(
    modifier: Modifier = Modifier,
    label: String,
    placeholder: String = "",
    enabled: Boolean = true,
    isMobile: Boolean = false,
    value: String,
    onValueChange: (String) -> Unit,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(8.px)
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(2.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            /*Image(
                src = "/localisate.svg",
                description = "localisate",
                modifier = Modifier.size(18.px)
            )*/
            FaLocationDot(
                modifier = Modifier.margin(right = 8.px),
                size = IconSize.SM
            )

            SpanText(
                text = label,
                modifier = Modifier
                    .fontSize(if (isMobile) 14.px else 18.px)
                    .fontWeight(FontWeight.Bold)
            )
        }
        Input(
            type = InputType.Text,
            attrs = FormlocalisationStyle.toModifier()
                .toAttrs {
                    value(value)
                    if (placeholder.isNotEmpty()) attr("placeholder", placeholder)
                    if (!enabled) attr("disabled", "")
                    onInput { event ->
                        if (enabled) onValueChange(event.value)
                    }
                }
        )
    }
}